import { render, staticRenderFns } from "./TagAndSubTagsList.vue?vue&type=template&id=dc337c1e&scoped=true&"
import script from "./TagAndSubTagsList.vue?vue&type=script&lang=js&"
export * from "./TagAndSubTagsList.vue?vue&type=script&lang=js&"
import style0 from "./TagAndSubTagsList.vue?vue&type=style&index=0&id=dc337c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc337c1e",
  null
  
)

export default component.exports